import { apiRequest } from './client'
import type {
  SilkPayStorageOrderResponse,
  SilkPaymentMethod,
  SilkStorageAddonOrder,
  SilkStorageAddonPlan,
  SilkStorageQuota,
  SilkUserStorageAddon,
} from './types'

export type SilkUserCustomStorageConfig = {
  provider?: string
  bucket?: string
  region?: string
  endpoint?: string
  access_key_id?: string
  public_base_url?: string
  prefix?: string
}

export type SilkUserCustomStorage = {
  configured: boolean
  storage_config?: SilkUserCustomStorageConfig
}

export const storageApi = {
  quota: () => apiRequest<SilkStorageQuota>('/api/v1/storage/quota'),

  addonPlans: () =>
    apiRequest<{ items: SilkStorageAddonPlan[] }>('/api/v1/storage/addon-plans'),

  paymentMethods: () =>
    apiRequest<{ methods: SilkPaymentMethod[] }>('/api/v1/storage/payment-methods'),

  subscribe: (body: { plan_code: string }) =>
    apiRequest<SilkUserStorageAddon>('/api/v1/storage/addons/subscribe', {
      method: 'POST',
      body,
    }),

  createOrder: (body: { plan_code: string; channel: string }) =>
    apiRequest<SilkStorageAddonOrder>('/api/v1/storage/addons/orders', {
      method: 'POST',
      body,
    }),

  payOrder: (orderId: string) =>
    apiRequest<SilkPayStorageOrderResponse>(
      `/api/v1/storage/addons/orders/${encodeURIComponent(orderId)}/pay`,
      { method: 'POST' },
    ),

  getOrder: (orderId: string) =>
    apiRequest<SilkStorageAddonOrder>(
      `/api/v1/storage/addons/orders/${encodeURIComponent(orderId)}`,
    ),

  getCustomConfig: () =>
    apiRequest<SilkUserCustomStorage>('/api/v1/storage/custom-config'),

  putCustomConfig: (body: Record<string, string>) =>
    apiRequest<SilkUserCustomStorage>('/api/v1/storage/custom-config', {
      method: 'PUT',
      body,
    }),

  deleteCustomConfig: () =>
    apiRequest<{ ok: boolean }>('/api/v1/storage/custom-config', {
      method: 'DELETE',
    }),
}

/** 字节数 → 用户可读容量(GB 优先) */
export function formatStorageBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B'
  const gb = bytes / (1024 * 1024 * 1024)
  if (gb >= 1) return `${gb.toFixed(gb >= 10 ? 0 : 1)} GB`
  const mb = bytes / (1024 * 1024)
  if (mb >= 1) return `${mb.toFixed(1)} MB`
  return `${Math.max(1, Math.round(bytes / 1024))} KB`
}
